import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileLines } from '@fortawesome/pro-light-svg-icons/faFileLines'
import { faList } from '@fortawesome/pro-light-svg-icons/faList'
import { faTrophy } from '@fortawesome/pro-light-svg-icons/faTrophy'
import { faArrowRotateLeft } from '@fortawesome/pro-light-svg-icons/faArrowRotateLeft'
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock'
import { useTranslation } from 'react-i18next'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import moment from 'moment'
import { IEvaluationResume } from 'models/evaluation.model'
import { getUserSession } from 'helpers/getUserSession.helper'
import { Name, Details } from './styled'
import 'moment/min/locales'

moment.locale(getUserSession().lang)

export interface IProps {
  evaluation: IEvaluationResume
}

const EvaluationDetails = ({ evaluation }: IProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Name>
        <FontAwesomeIcon icon={faFileLines as IconProp} />
        <div>{evaluation.name}</div>
      </Name>
      <Details>
        {evaluation.completionDate ? (
          <div>
            <FontAwesomeIcon icon={faClock as IconProp} />
            <div>
              <div>{t('components.courseSidebar.completionDate')}</div>
              <div>
                {moment(evaluation.completionDate)
                  .format(`D [${t('components.courseSidebar.of')}] MMMM, YYYY`)
                  .toLowerCase()}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div>
              <FontAwesomeIcon icon={faList as IconProp} />
              <div>{`${evaluation.totalQuestions} ${t(
                'components.courseSidebar.totalQuestions'
              )}`}</div>
            </div>
            <div>
              <FontAwesomeIcon icon={faTrophy as IconProp} />
              <div>{`${evaluation.minimumPassingScore} ${t(
                'components.courseSidebar.minimumPassingScore'
              )}`}</div>
            </div>
            <div>
              <FontAwesomeIcon icon={faArrowRotateLeft as IconProp} />
              <div>
                {t('components.courseSidebar.attemptsRemaining', {
                  attemptsRemaining: evaluation.attemptsRemaining,
                  attemptsAllowed: evaluation.maxRetries,
                })}
              </div>
            </div>
          </>
        )}
      </Details>
    </>
  )
}

export default EvaluationDetails
